module.exports = __webpack_public_path__ + "img/symbol-time-left.c9d26d2c.png";